<template>
    <div v-if="type === 'flat'" class="step">
        <div class="row">
            <div class="col-md-6">
                <hr class="pb-4">
                <div class="form-group row align-items-center">
                    <label for="ownership" class="font-weight-medium required col-lg-6">{{ $t('parameters.form.names.ownership') }}</label>
                    <div class="col-lg-6">
                        <select id="ownership" name="ownership" class="custom-select w-100" v-model="chosenOwnership"
                                required>
                            <option v-for="ownership in ownerships" :value="ownership.value">
                                {{ $t('parameters.form.ownership.' + ownership.value) }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="local_type" class="form-label col-lg-6">{{ $t('parameters.form.names.disposition') }}</label>
                    <div class="col-lg-6">
                        <select id="local_type" name="local_type" class="custom-select w-100" v-model="chosenLocalType">
                            <option v-for="localType in localTypes" :value="localType.value">
                                {{ $t('parameters.form.local_type.' + localType.value) }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="construction" class="form-label col-lg-6">{{ $t('parameters.form.names.construction') }}</label>
                    <div class="col-lg-6">
                        <select id="construction" name="construction" class="custom-select w-100"
                                v-model="chosenConstruction">
                            <option v-for="construction in constructions" :value="construction.value">
                                {{ $t('parameters.form.constructions.' + construction.value) }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="type === 'house'" class="step">
        <div class="row">
            <div class="col-12 p-0">
                <div class="col-md-6">
                    <hr>
                    <div class="form-group row align-items-center">
                        <label for="construction" class="form-label col-lg-6">{{ $t('parameters.form.names.construction') }}</label>
                        <div class="col-lg-6">
                            <select id="construction" name="construction" class="custom-select w-100"
                                    v-model="chosenConstruction">
                                <option v-for="construction in constructions" :value="construction.value">
                                    {{ $t('parameters.form.constructions.' + construction.value) }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "More",

        data: function() {
            return {
                ownerships: [
                    { value: null, text: 'Neuvedeno' },
                    { value: 'private', text: 'Osobní' },
                    { value: 'cooperative', text: 'Družstevní' },
                    { value: 'council', text: 'Státní/obecní' },
                    { value: 'other', text: 'Jiné' },
                ],

                localTypes: [
                    { value: null, text: 'Neuvedeno' },
                    { value: '1+kk', text: '1+kk' },
                    { value: '1+1', text: '1+1' },
                    { value: '2+kk', text: '2+kk' },
                    { value: '2+1', text: '2+1' },
                    { value: '3+kk', text: '3+kk' },
                    { value: '3+1', text: '3+1' },
                    { value: '4+kk', text: '4+kk' },
                    { value: '4+1', text: '4+1' },
                    { value: 'jiné', text: 'jiné' },
                ],

                constructions: [
                    { value: null, text: 'Neuvedeno' },
                    { value: 'brick', text: 'Cihlová' },
                    { value: 'wood', text: 'Dřevěná' },
                    { value: 'stone', text: 'Kamenná' },
                    { value: 'montage', text: 'Montovaná' },
                    { value: 'panel', text: 'Panelová' },
                    { value: 'mixed', text: 'Smíšená' },
                    { value: 'low_energy', text: 'Nízkonákladová' },
                    { value: 'other', text: 'Jiná' },
                ],

                chosenOwnership: null,
                chosenLocalType: null,
                chosenConstruction: null
            }
        },

        computed: {
            type: function () {
                let type = this.$parent.getType();
                if (type == "cottage" || type == "hut") {
                    type = "house";
                }

                return type;
            },

            required: function () {
                return this.type != "flat" || this.chosenOwnership != null && this.chosenOwnership.trim() !== '';
            }
        },

        mounted() {
            this.chosenOwnership = this.$parent.oldData.ownership;
            this.chosenLocalType = this.$parent.oldData.local_type;
            this.chosenConstruction = this.$parent.oldData.construction;
        }
    }
</script>

<style scoped>
    .form-group select {
        text-align: left !important;
        width: 100%;
    }

    .form-group label:first-of-type, .form-group select {
        display: inline-block;
        width: 45%;
    }

    .form-group select {
        width: 50%;
    }
</style>
